module.exports = __webpack_public_path__ + "img/button-home5.8ff7da28.png";